import { render, staticRenderFns } from "./feeDetailHisFee.vue?vue&type=template&id=165f26a2"
import script from "./feeDetailHisFee.vue?vue&type=script&lang=js"
export * from "./feeDetailHisFee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports